<template>
  <div
    class="flex h-28 w-full grow items-center justify-center self-center lg:justify-start lg:pl-4 banner:max-w-6xl banner:pl-0"
  >
    <m-router-link v-if="hasClickableLogo" :to="`/${customerStore.studio?.webUrl}`">
      <m-img
        class="max-h-[88px] max-w-[286px] object-contain"
        :src="customerStore.studio?.logoUrl"
        :alt="`${customerStore.studio?.name ?? 'Miller'} - Online Marketplace`"
      />
    </m-router-link>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue';
  import { useCustomerStore } from '@apps/customer/stores/customer.store';
  import MImg from '../MImg/MImg.vue';

  const customerStore = useCustomerStore();

  const hasClickableLogo = computed(() => customerStore.studio?.webUrl && customerStore.studio?.logoUrl);
</script>
